import script from "./xtx-message.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-message.vue?vue&type=script&setup=true&lang=js"

import "./xtx-message.vue?vue&type=style&index=0&id=428e568a&lang=less&scoped=true"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428e568a"]])

export default __exports__